<template>
  <span>
    <v-dialog v-model="dialog" persistent max-width="550">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          :small="small"
          :color="color"
          :disabled="signer.firmado"
          >{{ icon.reminder }}</v-icon
        >
      </template>
      <v-card>
        <v-card-title class="headline">{{
          signerReminderLabels.questionText
        }}</v-card-title>
        <v-card-text>{{
          signerReminderLabels.descriptionText.replace(
            '@',
            signer.nombreCompleto
          )
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="accent"
            text
            @click="raiseReminderSigner"
            :loading="loading"
            >{{ signerReminderLabels.positiveButtonText }}</v-btn
          >
          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
            :disabled="loading"
            >{{ signerReminderLabels.negativeButtonText }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mdiAlarm } from '@mdi/js'
import {
  signersStoreData,
  signersStoreActions
} from '@/modules/signers/store/signersStoreHelpers'
import { pushNotification, messageErrorResponse } from '@/store/helpers'

export default {
  name: 'SignerReminder',
  props: {
    signer: { type: Object, required: true },
    small: { type: Boolean, default: false },
    color: { type: String, default: 'grey darken-1' }
  },
  data() {
    return {
      icon: {
        reminder: mdiAlarm
      },
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...signersStoreData
  },
  methods: {
    ...signersStoreActions,
    raiseReminderSigner() {
      this.loading = true
      let notificacion = {
        id: this.signer.id,
        notificacion: 2
      }

      this.reminderSignerToDocument(notificacion)
        .then(result => {
          this.$emit('remindered')
          pushNotification(
            this.$store,
            result.data.data.notifications[0].successful.message,
            'info',
            'left',
            false,
            true
          )
        })
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          this.dialog = false
          this.loading = false
        })
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgSignerServiceReminderError,
        'error',
        'left',
        false,
        true
      )
    }
  }
}
</script>
